import React from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import config from '../config';

const AlbumCard = ({ album, onDelete }) => {
  return (
    <div className="bg-white rounded-lg overflow-hidden transition-all duration-200 hover:shadow-md group">
      <div className="relative">
        <div className="h-44 w-full overflow-hidden bg-gray-100">
          {album.coverArtUrl ? (
            <img 
              src={album.coverArtUrl} 
              alt={album.title} 
              className="w-full h-full object-cover"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-gray-400">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3" />
              </svg>
            </div>
          )}
        </div>
        <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-10 transition-all duration-200 flex items-center justify-center opacity-0 group-hover:opacity-100">
          <Link 
            to={`/albums/${album.id}`}
            className="p-2 bg-white rounded-full shadow-md text-red-600 transform scale-90 group-hover:scale-100 transition-all duration-200"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </Link>
        </div>
      </div>
      <div className="p-3">
        <Link to={`/albums/${album.id}`} className="no-underline">
          <h3 className="text-sm font-medium text-gray-900 hover:text-red-600 transition-colors">{album.title}</h3>
        </Link>
        <p className="text-xs text-gray-500 mt-1 line-clamp-2 h-8">{album.description}</p>
        <div className="flex justify-between items-center mt-2">
          <span className="text-xs text-gray-500">{album.songs ? (album.songs.length + ' ' + (album.songs.length === 1 ? 'song' : 'songs')) : ''}</span>
          <div className="flex space-x-2">
            <Link 
              to={`/albums/${album.id}`}
              className="text-xs text-red-600 font-medium hover:text-red-500 transition-colors"
            >
              Details
            </Link>
            <button
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                if (window.confirm(`Are you sure you want to delete "${album.title}"?`)) {
                  axios.delete(`${config.API_URL}/albums/${album.id}`)
                    .then(() => {
                      if (onDelete) onDelete(album.id);
                    })
                    .catch(error => {
                      console.error('Error deleting album:', error);
                      alert('Failed to delete album. Please try again.');
                    });
                }
              }}
              className="text-xs text-gray-500 hover:text-red-600 transition-colors"
              aria-label="Delete album"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlbumCard;
